import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_WHATSAPP_API_URL,
});
API.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("token");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export const getContacts = () =>
  API.get("/api/flask/messages/contacts");

export const getMessages = (phone) =>
  API.get(`/api/flask/messages/messages/${phone}`);

export const sendMessage = (payload) =>
  API.post("/api/flask/messages/send-template-message", payload);

export const sendTemplate = (payload) =>
  API.post("/api/flask/messages/send-template",payload);

export const uploadContacts = (formData) => {
  return API.post(
    "/api/flask/messages/contacts/upload",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};
export const deleteContacts = () =>
  API.delete("/api/flask/messages/contacts/delete-all");
export const deleteContact = (phone) =>
  API.delete(`/api/flask/messages/contact/${phone}`);
export const addContacts=(newContact)=>{
  return API.post(
    "/api/flask/messages/contacts",
    newContact
  );
}
export const getTemplates = () => {
    return API.get("/api/flask/messages/templates");
};
export const deleteTemplate = (templateId) => {
  return API.delete(`/api/flask/messages/delete-template/${templateId}`);
};
export const addTemplate = (data) => {
    return API.post(
       "/api/flask/messages/add-templates",
        data
    );
};
export default API;


